// $(document).ready(()=> {
//   if($('.product-camp').length) {
//     if($('#fullWeek').attr('data-avail') == 'true') {
//       $('.fullWeek-wrapper').click()
//     } else {
//       $('[data-variant-price]').hide()
//       $('#singleDays').click()
//     }

//     $('[data-product-option="option1"], [data-product-option="option2"] ').on('change', function() {
//       if($('#fullWeek').length) {
//         setTimeout(()=> {
//           if($('#fullWeek').attr('data-avail')) {
//             $('#fullWeek').click()
//           } else {
//             $('#singleDays').click()
//           }

  
//           let currentVariant = window.location.href.split('variant=')[1] //change full week price attr
//           $('#product-select option').each((index, el) => {
//             if($(el).val() == currentVariant) {
//               $('#full_week_price').attr('data-full-price', $(el).attr('data-price')) 
//             }
//           })

//         }, 500) 
//       }
//     })


//     // $('#singleDays').on('change', function(e) {
//     $('.singleDays-wrapper').on('click', function(e) {
//       e.stopPropagation()
//       $('.weekDay').removeClass('active')
//       $('.fullWeek-wrapper').removeClass('active')

// //       if($('.singleDays-wrapper input[type="radio"]:checked').val() == 'Single days') {

//         $('.js-open-modal.product-form-inline-atc-button')
//           .addClass('disabled')
//           .text('Please select days')
//         $('[data-variant-price]').hide()
       
//         if($('.weekDay').not('.unavailable').length) { 
//           $('.weekDay').not('.unavailable').eq(0).click().click()
//           let elem = $('.weekDay').not('.unavailable').eq(0)
//           var optionValue = 0
//           setDays(elem, optionValue)
//         }
//       // }
//     })

//     $('.weekDay').on('click', function(e) {
//       e.stopPropagation()

//       if($(this).hasClass('unavailable')) {
//         return
//       }

//       let elem = this
//       $(this).toggleClass('active')

//       let optionValue = $('.weekDay.active').length
//       setDays(elem, optionValue)
//       setDayProps(elem)
//       setSelectedDaysText() 
//     })

//     $('.fullWeek-wrapper').on('click', function() {
//       let elem = this
//       setDays(elem, 'week')

//       let option_id = $(this)
//                         .parents('.product__option')
//                         .find('.option-select-input.daysSelect')
//                         .attr('data-product-option')
//       if(option_id) {
//         if($('input[data-option-hidden="' + option_id + '"]').length) {
//           $('input[data-option-hidden="' + option_id + '"]').val('week');
//         }
//       }
       
//       if($('#fullWeek').attr('data-avail') == 'false' ) {
//         $('.product-form-inline-atc-button').hide()
//         $('.js-open-modal.product-form-inline-atc-button')
//           .show()
//           .addClass('disabled')
//           .text('The selected days are not available')
//         $('[data-variant-price]').hide()
//       }

//     })

//     function setSelectedDaysText() {
//       let optionValue = $('.weekDay.active').length
//       let dayText = optionValue == 1 ? 'day' : 'days'

//       if( optionValue < 1 ) {
//         $('.selectedDays-wrapper').hide()
//         $('.js-open-modal.product-form-inline-atc-button')
//           .addClass('disabled')
//           .text('Please select days')
//         return
//       }
  
//       $('.selectedDays').html(`<strong>${optionValue}</strong> ${dayText}`)
//       $('.selectedDays-wrapper').show()
//     }

//   function setDayProps(elem) {
//     let option_id = $(elem)
//                       .parents('.product__option')
//                       .find('.option-select-input.daysSelect')
//                       .attr('data-product-option')
//     if(option_id) {
//       let value = []
//       $('.weekDay.active').each((index, el) => {
//         if($(el).text() !== ' ') {
//           value.push($(el).text())
//         }
// 			})
//       if($('input[data-option-hidden="' + option_id + '"]').length) {
//         $('input[data-option-hidden="' + option_id + '"]').val(value.join(', '));
//       }
//     }
//   }

//   function setDays(elem, optionValue) {
//     let weekDaysAvailable = $('.weekDay:not(.unavailable)').length

//       $(elem)
//       .parents('.product__swatch-days')
//       .prev()
//       .find('.selectric-scroll')
//       .find('li')
//       .each(function (index, el) {
//         if($(el).text().indexOf(optionValue) > -1) {
//             if($(el).hasClass('disabled')) {
//               $('.js-open-modal.product-form-inline-atc-button')
//                 .addClass('disabled')
//                 .text('The selected days are not available')
//               $('[data-variant-price]').hide()
//             } else {
//               $('.js-open-modal.product-form-inline-atc-button')
//                 .removeClass('disabled')
//                 .text('book now')
//               $('[data-variant-price]').show()
//             }

//         // if($(el).text() == 'week' && $('#fullWeek').attr('data-avail') == 'false' ) {
//         //   $('.product-form-inline-atc-button')
//         //   .addClass('disabled')
//         //   .text('The selected days are not available')
//         //   $('[data-variant-price]').hide()
//         // }

//           if (optionValue == weekDaysAvailable) {
//             $(el).click()
          
//             let fullWeekPrice = $('#full_week_price').attr('data-full-price')
//             let currentVariantPrice = $('[data-variant-price]').eq(0).text()

//             if(currentVariantPrice == fullWeekPrice) {
//               $('#fullWeek').prop('checked', true)
//               $('#fullWeek').click()
//             }
      
//           } else {
//             $(el).click()
//           }
//         }
//       })

//       if(optionValue == 0) {
//         $('.js-open-modal.product-form-inline-atc-button')
//         .addClass('disabled')
//         .text('Please select days')
//         $('[data-variant-price]').hide()
//       }
//     }
//   }
// })

$(document).ready(()=> {
  if($('.product-camp').length) {
    console.log(JSON.parse($('[data-product-json]').html()))
    let data = JSON.parse($('[data-product-json]').html())

    selectors = {
      $fullweekInput: $('#fullWeek'),
      $fullweekWrapper: $('.fullWeek-wrapper'),
      $singleDaysInput: $('#singleDays'),
      $button: $('.product-form-inline-atc-button'),
      $buttonModal:  $('.js-open-modal.product-form-inline-atc-button'),
      $priceContainer: $('[data-variant-price]'),
      $weekDay: $('.weekDay'),
      $selectedDaysWrapper: $('.selectedDays-wrapper')
    }

    // First load check
    if(selectors.$fullweekInput.attr('data-first-avail') == 'true') {
      selectors.$fullweekWrapper.click()
    } else {
      selectors.$singleDaysInput.click()
      selectors.$button
          .addClass('disabled')
          .text('Please select days')
      selectors.$priceContainer.hide()    
    }

    $('[data-product-option="option1"], [data-product-option="option2"] ').on('change', function() {
      if(selectors.$fullweekInput.length) {
        let week = false
        
        setTimeout(()=> {
          let currentVariantSelected = window.location.href.split('variant=')[1]
          let currentVariant = [...data.variants].filter(el => {
            if($(el)[0].id == currentVariantSelected) {
              return el
            }
          })

          if (currentVariant[0].options.includes('week')) {
            week = true
          }

          if (week && currentVariant[0].available) {
            selectors.$fullweekInput.click()
            selectors.$buttonModal
              .removeClass('disabled')
              .text('Book now')
          } else {
            selectors.$singleDaysInput.click()
            selectors.$weekDay.removeClass('active')
            selectors.$fullweekWrapper.removeClass('active')
            selectors.$selectedDaysWrapper.hide() 
            selectors.$button
              .addClass('disabled')
              .text('Please select days')
          }
        }, 500) 
      }
    })


    $('.singleDays-wrapper').on('click', function(e) {
      e.stopPropagation()
      selectors.$weekDay.removeClass('active')
      selectors.$fullweekWrapper.removeClass('active')
      selectors.$selectedDaysWrapper.hide()
      selectors.$button
        .addClass('disabled')
        .text('Please select days')
      selectors.$priceContainer.hide()
    })

    selectors.$weekDay.on('click', function(e) {
      e.stopPropagation()

      if($(this).hasClass('unavailable')) {
        return
      }

      let elem = this
      $(this).toggleClass('active')

      let optionValue = $('.weekDay.active').length

      setDays(elem, optionValue)
      setDayProps(elem)
      setSelectedDaysText() 
    })

    selectors.$fullweekWrapper.on('click', function() {
      let elem = this

      if(window.location.href.indexOf('variant=') > -1 ) {
        let currentVariantSelected = window.location.href.split('variant=')[1]
        let currentVariant = [...data.variants].filter(el => {
          if($(el)[0].id == currentVariantSelected) {
            return el
          }
        })
        setDays(elem, 'week')

        let option_id = $(this)
                          .parents('.product__option')
                          .find('.option-select-input.daysSelect')
                          .attr('data-product-option')
        if (option_id) {
          if ($('input[data-option-hidden="' + option_id + '"]').length) {
              $('input[data-option-hidden="' + option_id + '"]').val('week');
          }
        }

      } else if (selectors.$fullweekInput.attr('data-first-avail') == 'false' ) {
        selectors.$button.hide()
        selectors.$buttonModal
          .show()
          .addClass('disabled')
          .text('The selected days are not available')
        selectors.$priceContainer.hide()
      }

    })

    function setSelectedDaysText() {
      let optionValue = $('.weekDay.active').length
      let dayText = optionValue == 1 ? 'day' : 'days'

      if( optionValue < 1 ) {
        selectors.$selectedDaysWrapper.hide()
       selectors.$buttonModal
          .addClass('disabled')
          .text('Please select days')
        return
      }
  
      $('.selectedDays').html(`<strong>${optionValue}</strong> ${dayText}`)
      selectors.$selectedDaysWrapper.show()
    }

  function setDayProps(elem) {
    let option_id = $(elem)
                      .parents('.product__option')
                      .find('.option-select-input.daysSelect')
                      .attr('data-product-option')
    if(option_id) {
      let value = []
      $('.weekDay.active').each((index, el) => {
        if($(el).text() !== ' ') {
          value.push($(el).text())
        }
			})
      if($('input[data-option-hidden="' + option_id + '"]').length) {
        $('input[data-option-hidden="' + option_id + '"]').val(value.join(', '));
      }
    }
  }

  function setDays(elem, optionValue) {
    let weekDaysAvailable = $('.weekDay:not(.unavailable)').length

      $(elem)
      .parents('.product__swatch-days')
      .prev()
      .find('.selectric-scroll')
      .find('li')
      .each(function (index, el) {
        if($(el).text().indexOf(optionValue) > -1) {
            if($(el).hasClass('disabled')) {
              selectors.$button
                .addClass('disabled')
                .text('The selected days are not available')
              selectors.$priceContainer.hide()
            } else {
              selectors.$button
                .removeClass('disabled')
                .text('book now')
              selectors.$priceContainer.show()
            }

          if (optionValue == weekDaysAvailable) {
            $(el).click()
          
            let fullWeekPrice = $('#full_week_price').attr('data-full-price')
            let currentVariantPrice = selectors.$priceContainer.eq(0).text()

            if(currentVariantPrice == fullWeekPrice) {
              selectors.$fullweekInput.prop('checked', true)
              selectors.$fullweekInput.click()
            }
          } else {
            $(el).click()
          }
        }
      })

      if(optionValue == 0) {
       selectors.$buttonModal
        .addClass('disabled')
        .text('Please select days')
        selectors.$priceContainer.hide()
      }
    }
  }
})



